<label *ngIf="headerPafLabel"
       class="control-label"
       [paflabel]="headerPafLabel">
</label>

<kendo-combobox
    [data]="lstDatasWithDisplay"
    [textField]="'_$display'"
    [valueField]="'Id'"
    [valuePrimitive]="true"
    [(ngModel)]="valueId"
    [disabled]="disabled"
    [kendoDropDownFilter]="sharedSvc.filterSettings"
    style="width:100%;">

    <ng-template kendoComboBoxItemTemplate let-item>
      <span class="kendo-dropdown-item">{{ item._$cboDisplay }}</span>
    </ng-template>
</kendo-combobox>


<pre *ngIf="sharedSvc.debug">valueId = {{ valueId }}</pre>
<pre *ngIf="sharedSvc.debug">bindToId = {{ !!bindToId }}</pre>
<pre *ngIf="sharedSvc.debug">object = {{ value | json }}</pre>

<!-- Validation UI -->
<span class="text-danger"
      *ngIf="required && !valueId && !disabled">
    Champ obligatoire
</span>
